export const itemtype = [
  { id: 1, label: 'Goods' },
  { id: 2, label: 'Services' },
];
